import axios from "axios";

// Opinion / columnist articles ("Kolumna") — newest-first from the dedicated
// opinion_articles table.
// GET /api/opinion?limit=N → [{ link, title, author, portal, section,
//                              summary, imageUrl, publishedAt }]

export const fetchOpinion = async (limit = 60) => {
  const attempt = () =>
    axios.get(`${process.env.REACT_APP_API_URL}/api/opinion`, {
      params: { limit },
      timeout: 45000,
    });

  for (let i = 0; i < 2; i++) {
    try {
      const res = await attempt();
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      if (i === 1) {
        console.warn("opinion fetch failed:", err.message);
        return [];
      }
      await new Promise((r) => setTimeout(r, 1500));
    }
  }
  return [];
};
